import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { SiteService } from "../../util/services/site";
import { showErrorResponse } from "../../util/varibles/global";
import { notify, NotifyCode } from "../../util/varibles/message";
import { siteMonitoringActions } from "./reducer";

function* getSitesWatcher(): Generator {
    try {
        const sites = yield call(SiteService.getSimulation)
        yield put(siteMonitoringActions.getSitesSuccess(sites))
    } catch (error) {
        yield put(siteMonitoringActions.getSitesFailure())
    }
}

function* updateSitesWatcher(args: PayloadAction<any>) {
    try {
        const site = args.payload;
        yield call(SiteService.updateSimulation, site)
        notify.sucess(NotifyCode.S2)([site.name])
        yield put(siteMonitoringActions.getSitesRequest())
    } catch (error) {
        showErrorResponse('Update failure', error);
    }
}

export default function* siteMonitoringSaga() {
    yield all([
        takeEvery(siteMonitoringActions.getSitesRequest.type, getSitesWatcher),
        takeEvery(siteMonitoringActions.updateSiteRequest.type, updateSitesWatcher)
    ])
}
